import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { SubentityState } from 'app/projects/subentity/src/lib/models/subentity.state';
import {
    CreateExperienceWidgetSuccess,
    DeleteExperienceWidget,
    DeselectSelectedExperienceWidgets,
    SearchExperienceWidgets,
    SelectFilteredExperienceWidgets,
    SetExperienceWidgets,
    ToggleSelectedExperienceWidget,
} from '../actions';
import { AddExperienceWidgets } from '../actions/add-entities.action';
import { ExperienceWidget } from './experience-widget.model';
import { ExperienceWidgetState } from './experience-widget.state';
import { ExperienceWidgetsStateModel } from './experience-widgets.state-model';

@State<ExperienceWidgetsStateModel>({
    name: 'experienceWidgets',
    defaults: new ExperienceWidgetsStateModel(),
})
@Injectable()
export class ExperienceWidgetsState extends SubentityState<ExperienceWidget> {
    @Selector([ExperienceWidgetState.getEntities])
    static getFilteredEntities(state: ExperienceWidgetsStateModel, experiences: ExperienceWidget[]): ExperienceWidget[] {
        if (!experiences) {
            return null;
        }

        return experiences
            .filter((item) => state.filtered.indexOf(item.id) !== -1)
            .map((item) => {
                return [state.list.indexOf(item.id), item];
            })
            .sort((a: [number, ExperienceWidget], b: [number, ExperienceWidget]) => {
                return a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0;
            })
            .map((x: [number, ExperienceWidget]) => x[1]);
    }

    @Selector()
    static getSelectedEntityIds(state: ExperienceWidgetsStateModel): string[] {
        return state.selected;
    }

    @Selector()
    static getSearchTerm(state: ExperienceWidgetsStateModel): string {
        return state.searchTerm;
    }

    constructor(private store: Store) {
        super(null, 0);

        // this._propstoSearch = [...MaxBrainExperienceWidget.props_to_search];
    }

    @Action(AddExperienceWidgets)
    addEntities(ctx: StateContext<ExperienceWidgetsStateModel>, action: AddExperienceWidgets): void {
        const experiences = this.store.selectSnapshot(ExperienceWidgetState.getEntities) || [];

        this._patchSubentities(ctx, { payload: { subentityIds: action.payload.map((entity) => entity.id) } }, experiences);
    }

    @Action(CreateExperienceWidgetSuccess)
    createEntity(ctx: StateContext<ExperienceWidgetsStateModel>, action: CreateExperienceWidgetSuccess): void {
        const experiences = this.store.selectSnapshot(ExperienceWidgetState.getEntities) || [];

        this._patchSubentities(ctx, { payload: { subentityIds: [action.payload.id] } }, experiences);
    }

    @Action(DeleteExperienceWidget)
    deleteEntity({ getState, patchState }: StateContext<ExperienceWidgetsStateModel>, { payload }: DeleteExperienceWidget): void {
        const state = getState();

        patchState({
            list: [...state.list.filter((subentityId) => subentityId !== payload)],
            selected: [...state.selected.filter((subentityId) => subentityId !== payload)],
            filtered: [...state.filtered.filter((subentityId) => subentityId !== payload)],
        });
    }

    @Action(SetExperienceWidgets)
    setEntities(ctx: StateContext<ExperienceWidgetsStateModel>, action: SetExperienceWidgets): void {
        this._setSubentities(ctx, action, null);
    }

    @Action(ToggleSelectedExperienceWidget)
    toggleSelect(ctx: StateContext<ExperienceWidgetsStateModel>, action: ToggleSelectedExperienceWidget): void {
        this._toggleSelectedSubentity(ctx, action);
    }

    @Action(SelectFilteredExperienceWidgets)
    selectAll(ctx: StateContext<ExperienceWidgetsStateModel>): void {
        this._selectFilteredSubentities(ctx);
    }

    @Action(DeselectSelectedExperienceWidgets)
    deselectAll(ctx: StateContext<ExperienceWidgetsStateModel>): void {
        this._deselectSelectedSubentities(ctx);
    }

    @Action(SearchExperienceWidgets)
    search(ctx: StateContext<ExperienceWidgetsStateModel>, action: SearchExperienceWidgets): void {
        const experiences = this.store.selectSnapshot(ExperienceWidgetState.getEntities);

        this._searchSubentities(ctx, action, experiences);
    }
}
